var e={exports:{}};export{e as __module};
//# sourceMappingURL=dom-to-image.js.map
